import { Observable } from 'rxjs'
import { VideoPlayerScreenErrorCode } from '../../../shared/video-player/models/video-player-screen-error-code.model'
import { VideoPlayerMeta } from '../../models/stream-tile'
import { Level } from 'hls.js'

export interface HlsLoaderResponse<T = any> {
  error?: {
    code: number
    message?: string
    meta?: T
  }
  success?: {
    hlsUrl: string
    meta?: T
  }
}
export type HlsLoader<TMeta = any> = (
  videoReferenceId: string,
  isFreeStream: boolean,
  meta: VideoPlayerMeta
) => Observable<HlsLoaderResponse>

export interface IVideoQuality {
  levels: ReadonlyArray<Level>
  manualLevel: number
}

export interface IVideoScrubber {
  currentTime: number
  duration: number
  isAtLiveHead?: boolean
}

export type uuidPerTabGenFn = () => string

export enum ViewMode {
  ERROR,
  PLAYER
}

export interface ErrorInterface {
  code: VideoPlayerScreenErrorCode
  message?: string
}
